import { render, staticRenderFns } from "./AttractionsList.vue?vue&type=template&id=396b99fb&scoped=true&"
import script from "./AttractionsList.vue?vue&type=script&lang=js&"
export * from "./AttractionsList.vue?vue&type=script&lang=js&"
import style0 from "./AttractionsList.vue?vue&type=style&index=0&id=396b99fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b99fb",
  null
  
)

export default component.exports